export default "__VITE_ASSET__D89jmaP1__"